import PCard from './p-card.vue';

export default PCard;
